<template>
  <div>
    <div class="main-p main-p8" v-show="true">
      <p class="tit hidden-sm-and-down">修改密码</p>
      <p class="m-tit hidden-md-and-up">请填写如下资料</p>
      <div class="p6-form">
        <el-form :model="changepasslist" status-icon :rules="P8rules" ref="p8ruleForm" label-width="2.7777rem" label-position="left">
          <el-form-item label="请输入旧密码" prop="oldpass"><el-input type="password" v-model="changepasslist.oldpass"></el-input></el-form-item>
          <el-form-item label="请输入新密码" prop="newpass"><el-input type="password" v-model="changepasslist.newpass"></el-input></el-form-item>
          <el-form-item label="请再次输入新密码" prop="checknewpass"><el-input type="password" v-model="changepasslist.checknewpass"></el-input></el-form-item>
          <el-form-item class="is-required" label="安全验证">
            <drag-verify
              :width="isphone"
              :height="44"
              handlerIcon="el-icon-d-arrow-right"
              successIcon="el-icon-check"
              text="请将滑块拖动到右侧"
              success-text="验证成功"
              background="#ddd"
              progress-bar-bg="#2ACBF8"
              text-size="0.3rem"
              :circle="false"
              @passcallback="p8passcall"
            ></drag-verify>
          </el-form-item>
        </el-form>
        <div class="form-sub"><div class="form-sub-btn" @click="p8submit()">提交资料</div></div>
      </div>
    </div>
  </div>
</template>
<script>
import dragVerify from 'vue-drag-verify';
import { editpw, editsave } from '../../api';
import qs from 'qs';
export default {
  name: 'cityG8',
  data() {
    const _this = this;
    var checknewpass = (rule, value, callback) => {
      var regx = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,20}$/;
      if (_this.changepasslist.newpass == _this.changepasslist.oldpass) {
        callback(new Error('新旧密码不能一致'));
      } else {
        if (_this.changepasslist.newpass.match(regx) == null) {
          callback(new Error('密码为数字+英文组合'));
        } else {
          callback();
        }
      }
    };
    var checknewpass2 = (rule, value, callback) => {
      var regx = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,20}$/;
      if (_this.changepasslist.newpass != _this.changepasslist.checknewpass) {
        callback(new Error('请再次输入相同新密码'));
      } else {
        if (_this.changepasslist.newpass.match(regx) == null) {
          callback(new Error('密码为数字+英文组合'));
        } else {
          callback();
        }
      }
    };
    return {
      isphone: 0,
      changepasslist: {
        oldpass: '',
        newpass: '',
        checknewpass: '',
        P8text: false
      },
      P8rules: {
        oldpass: [{ required: true, message: '原密码不能为空', trigger: 'blur' }, { min: 6, max: 24, message: '密码至少为6位数' }],
        newpass: [{ required: true, validator: checknewpass, trigger: 'blur' }, { min: 6, max: 24, message: '密码为6至24位数字+英文组合' }],
        checknewpass: [{ required: true, validator: checknewpass2, trigger: 'blur' }, { min: 6, max: 24, message: '密码为6至24位数字+英文组合' }]
      }
    };
  },
  mounted () {
    // this.isphone = parseInt($('.main-p8 .p6-form').width())
    if (/iphone|ipad|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|android|iPod/i.test(navigator.userAgent.toLowerCase())) {
      if ($('.main-p8 .p6-form').width() == 0) {
        this.$nextTick(() => {
          this.isphone = parseInt($('.main-p8 .m-tit')[7].clientWidth - 1)
        })
      } else {
        this.isphone = parseInt($('.main-p8 .p6-form').width())
      }
    } else {
      this.isphone = 300
    }
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo.userId === '97d7581471354cf4a84ec06218da7ad2') {
      this.$confirm('请先登录账号,点击下方按钮跳转到登录界面', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        center: true,
        showCancelButton: false,
        showClose: false,
        closeOnPressEscape: false
      }).then(() => {
        this.$router.push('/Login')
      })
    }
  },
  methods: {
    p8submit () {
      this.$refs.p8ruleForm.validate(valid => {
        if (valid) {
          if (!this.changepasslist.P8text) {
            this.$message({
              showClose: true,
              message: '请先进行安全验证',
              type: 'error',
              center: true
            });
            return ;
          } else {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'))
            let un = userInfo.userName
            let upw = this.getmd5(this.changepasslist.oldpass);
            editpw(un, upw).then(res => {
              if (res.data) {
                console.log(this.changepasslist.newpass)
                let list = {
                  SPONSOR_ID: userInfo.userId,
                  PASSWORD: this.getmd5(this.changepasslist.newpass)
                };
                editsave(qs.stringify(list)).then(res => {
                  if (res.data == 'ok') {
                    this.$message({
                      showClose: true,
                      message: '密码修改成功',
                      type: 'success',
                      center: true
                    });
                    setTimeout(() => {
                      window.location.reload();
                    }, 2000);
                  } else {
                    this.$message({
                      showClose: true,
                      message: '密码修改失败，请重新尝试',
                      type: 'error',
                      center: true
                    });
                  }
                });
              } else {
                this.$message({
                  showClose: true,
                  message: '原密码错误',
                  type: 'error',
                  center: true
                });
              }
            });
          }
        }
      });
    },
    p8passcall() {
      this.changepasslist.P8text = true;
    },
    getmd5(code) {
      return this.$md5(code);
    }
  },
  components: { dragVerify }
};
</script>

<style lang="stylus" scoped src="../../assets/css/CityG.styl">

</style>
<style scoped lang="stylus">
@media screen and (max-width: 990px){
  .G-container.zh {
    .main-p{
      &.main-p8{
        .m-tit{
          color #8d8d8d
          font-size 0.3703rem
          padding .4rem 0
          border-bottom 0.0185rem solid #e2e2e2
        }
        .p6-form{
          .form-sub{
            padding .4rem 0 .4rem 0
            .form-sub-btn{
              display block
              font-size 0.3703rem
              padding .2rem 0
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="stylus">
@media screen and (max-width: 990px){
  .G-container.zh {
    .content-box{
      .content{
        .main-p{
          &.main-p8{
            .p6-form{
              .el-input{
                width 100%
              }
              .el-form-item__label{
                width 100% !important
                float initial
              }
              .el-form-item__content{
                width 100%
                margin-left 0 !important
              }
              .drag_verify{

              }
            }
          }
        }
      }
    }
  }
}
</style>
